import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  outer: {
    display: 'block',
  },
  heading: {
    display: 'inline-block',
  //  width: '160px',
    fontWeight: 'bold',
    marginRight: '15px'
  },
  content: {
    display: 'inline-block',
  //  width: '200px'
  }
};

const Item = ({ heading, content }) => <div style={styles.outer}>
  <span style={styles.heading}>{heading}</span>
  <span style={styles.content}>{content}</span>
</div>;

Item.propTypes = {
  heading: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default Item;



// WEBPACK FOOTER //
// ./src/components/Query/QueryShow/Item.js